<template>
  <v-window-item value="others">
    <v-card-text>
      <v-card variant="outlined" class="mb-4">
        <v-card-title class="text-subtitle-1">
          <v-icon class="me-1" size="small">mdi-account-star</v-icon>
          Other Information
        </v-card-title>
        <v-card-text>
          <v-card variant="tonal" class="py-4">
            <v-row>
              <v-col cols="12" md="6">
                <v-list-item
                  prepend-icon="mdi-account-star-outline"
                  title="Extra Curricular Activities"
                  :subtitle="(userOtherInfoData?.extra_curricular_activities) || 'N/A'"
                />
                <v-list-item
                  prepend-icon="mdi-account-tie-outline"
                  title="Area of Specialization"
                  :subtitle="(userOtherInfoData?.area_of_specialization) || 'N/A'"
                />

                <v-list-item
                    prepend-icon="mdi-comment-text-outline"
                    title="Extra Curricular Remarks"
                    :subtitle="(userOtherInfoData?.extra_curricular_remarks) || 'N/A'"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-list-item
                  prepend-icon="mdi-text-box-edit-outline"
                  title="Specialization Remarks"
                  :subtitle="(userOtherInfoData?.specialization_remarks) || 'N/A'"
                />
              </v-col>
            </v-row>
          </v-card>
        </v-card-text>
      </v-card>

      <v-card variant="outlined">
        <v-card-title class="text-subtitle-1">
          <v-icon class="me-1" size="small">mdi-translate</v-icon>
          Language Proficiencies
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col
              v-for="language in userOtherInfoData?.language_proficiencies || []"
              :key="language.language"
              cols="12"
              md="6"
            >
              <v-card variant="tonal">
                <v-card-title class="text-subtitle-2">
                  {{ language.language || 'N/A' }}
                </v-card-title>
                <v-card-text>
                  <v-list-item
                    prepend-icon="mdi-pencil-outline"
                    title="Writing"
                    :subtitle="(language.writing) || 'N/A'"
                  />
                  <v-list-item
                    prepend-icon="mdi-book-open-outline"
                    title="Reading"
                    :subtitle="(language.reading) || 'N/A'"
                  />
                  <v-list-item
                    prepend-icon="mdi-microphone-outline"
                    title="Speaking"
                    :subtitle="(language.speaking) || 'N/A'"
                  />
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-alert
            v-if="!userOtherInfoData?.language_proficiencies?.length"
            type="info"
            variant="tonal"
          >
            No language proficiency information found.
          </v-alert>
        </v-card-text>
      </v-card>
    </v-card-text>
  </v-window-item>
</template>

<script setup>
defineProps({
  userOtherInfoData: {
    type: Object,
    default: () => ({})
  }
})
</script>
